import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { ThemeCssProps } from '../../../../defaultTheme'

export const buttonCss = css<ThemeCssProps>`
  width: 100%;
  text-align: center;
  font-weight: bold;

  border: ${props => props.theme.dropdown.border};
  background: ${props => props.theme.buttons.dropdown.background};
  border-radius: ${props => props.theme.buttons.dropdown.borderRadius};
  margin-top: 10px;
  & .button {
    justify-content: center;
  }
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: unset;
  &:hover,
  &:visited {
    text-decoration: none;
    color: unset;
  }
`

export const ItemGroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  line-height: 1;
  font-size: ${props => props.theme.dropdown.itemGroup.fontSize};
  margin: ${props => props.theme.dropdown.itemGroup.margin};
  color: ${props => props.theme.dropdown.itemGroup.color};
`
